import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2024 TrackMyExpenses. All rights reserved.</p>
      <p>Designed and developed by Cherag.</p>
    </footer>
  );
}

export default Footer;
